module.exports = __webpack_public_path__ + "static/img/gggggg_15.ea43d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_15.png
// module id = qrj+
// module chunks = 1